export default {
    root: ({ props }) => ({
        class: [
            'flex flex-wrap gap-1',
            'select-none align-bottom outline-transparent',
            'border border-transparent rounded-md [&>button]:rounded-none',
            '[&>button:first-child]:border-r-none [&>button:first-child]:rounded-r-none [&>button:first-child]:rounded-tl-md [&>button:first-child]:rounded-bl-md',
            '[&>button:last-child]:border-l-none [&>button:first-child]:rounded-l-none [&>button:last-child]:rounded-tr-md [&>button:last-child]:rounded-br-md',
            '[&>button:hover]:bg-surface-200 dark:[&>button:hover]:bg-surface-900',
            '[&>[data-p-checked="true"]:hover]:!bg-surface-900 dark:[&>[data-p-checked="true"]:hover]:!bg-surface-700',

            // Invalid State
            {
                'border-red-500 dark:border-red-400': props.invalid,
            }
        ]
    })
};
